<template>
    <b-form @submit="onSubmit" @reset="clearFilter">
        <div class="d-flex align-items-center">
            <div class="row flex-grow-1">
                <div class="col-6 d-flex align-items-center">
                    <label class="me-2">Desde:</label>
                    <input 
                        type="date" 
                        class="form-control form-control-sm" 
                        v-model="startDate"
                        :min="min" 
                        :max="max"
                        placeholder="Fecha creación inicial"
                    >
                </div>

                <div class="col-6 d-flex align-items-center">
                    <label class="me-2">Hasta:</label>
                    <input 
                        type="date" 
                        class="form-control form-control-sm" 
                        v-model="endDate"
                        :min="min" 
                        :max="max"
                        placeholder="Fecha creación final"
                    >
                </div>        
            </div>

            <div class="flex-shrink-1 ms-3">
                <button 
                    type="submit" 
                    class="btn btn-outline-primary btn-sm" 
                    :disabled="!enableSubmit">
                    Filtrar
                </button>

                <button
                    type="reset"
                    class="btn btn-outline-secondary btn-sm ms-2"
                    :disabled="!enableReset">
                    Limpiar  
                </button>        
            </div>
        </div>
    </b-form>
</template>
<script>
import {EventNames} from "@/plugins/enums";

export default {
    name: 'StatementDate',

    data() {
        return {
            startDate: null,
            endDate: null
        }
    },

    computed: {
        enableSubmit() {
            return this.startDate && this.endDate
        },
        enableReset() {
            return this.startDate || this.endDate
        },

        min() {
            return this.startDate ? this.startDate : null
        },

        max() {
            return this.endDate ? this.endDate : this.formatDateForInput(new Date())
        }
    },

    methods: {
        clearFilter() {
            this.startDate = null;
            this.endDate = null;
            this.$eventBus.$emit(EventNames.ClearFamilyStatementsDateFilter);
        },

        onSubmit(evt) {
            evt.preventDefault();
            this.$eventBus.$emit(EventNames.FilterFamilyStatementsByDate, {
                initDate: `${this.startDate}T00:00:00.000Z`,
                finalDate: `${this.endDate}T23:59:59.999Z`
            });
        },

        formatDateForInput(date) {
            // format to pass to max min attributes
            return date.toISOString().split('T')[0];
        },
    }

}
</script>
